module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Battle/images/bg-fort-battle.25093e9f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Battle/images/bg-fort-battle.png
// module id = 2502
// module chunks = 11